import { Box, Typography } from "@mui/material";
import ArchivedClientsTable from "./table";

const ArchivedClientsPage = () => {
  return (
    <Box p={"30px"}>
      <Typography mb={4} fontSize={"22px"} fontWeight={600}>
        Archived Clients
      </Typography>
      <ArchivedClientsTable />
    </Box>
  );
};

export default ArchivedClientsPage;
